import React from 'react'
import Popup from 'reactjs-popup'
import { eFormButtonsContainer } from '../common/cssclasses'
import NewActionButton from './ActionButtons/NewActionButton'
import DraftBtn from './servicesButtons/DraftBtn'
import SubmitServiceBtn from './servicesButtons/SubmitServiceBtn'
import { useTranslate } from './TranslationText'

export default function CustomPopUp({ trigger,isBid=false, title = "", content = "", onClick = "", btnText = "", disabled = false, ...props }) {
    const { translate } = useTranslate();

    async function doOnClock(close) {
        if (disabled) return;

        const result = await onClick();

        if (result === false) return;

        close();
    }


    return (
        <Popup
            trigger={trigger}
            modal
            closeOnEscape={false}
            closeOnDocumentClick={false}
            lockScroll={true}
            overlayStyle={{ zIndex: 5000 }}
            contentStyle={{ maxWidth: '80%', minWidth: '300px', }}
            {...props}
        >
            {(close) =>
            (
                <>
                    {!!title &&
                        < h4 className='fw-bold'>
                            {title}
                        </h4>
                    }
                    {!!content &&
                        <div className='popUpElemnts mb-main' style={isBid?{minHeight:'unset' , overflow:'hidden'}:{}}>
                            {content}
                        </div>
                    }
                    <div className={eFormButtonsContainer}>
                        <DraftBtn
                            onClick={close}
                            text={translate('web.close', 'Close')}
                        />
                        {!!onClick &&
                            <SubmitServiceBtn text={btnText} key={'submit'} onClick={() => doOnClock(close)} disabled={disabled} />
                        }
                    </div>
                </>
            )

            }
        </Popup >
    )
}
